import React, { useState } from 'react';

const PartnerPage = () => {
  const [formData, setFormData] = useState({
    businessName: '',
    contactName: '',
    email: '',
    phone: '',
    businessType: '',
    location: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setFormData({
      businessName: '',
      contactName: '',
      email: '',
      phone: '',
      businessType: '',
      location: '',
      message: ''
    });
    setTimeout(() => setSubmitted(false), 3000);
  };

  const benefits = [
    {
      icon: '🏪',
      title: 'Retail Partnership',
      description: 'Stock our products in your store and earn competitive margins'
    },
    {
      icon: '🚚',
      title: 'Distribution',
      description: 'Become a regional distributor for Sunkissed products'
    },
    {
      icon: '👥',
      title: 'Reseller Program',
      description: 'Join our reseller network and grow your business'
    },
    {
      icon: '📈',
      title: 'Growing Brand',
      description: "Partner with a brand that's loved by customers"
    }
  ];

  return (
    <div className="bg-white min-h-screen">
        <section className="py-20 px-8 md:px-[140px] bg-gradient-to-b from-[#8e0707] to-[#6b0505]">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-6xl font-medium text-white mb-6">
              Be a Partner
            </h1>
            <p className="text-xl text-white/80 max-w-2xl mx-auto">
              Join the Sunkissed family and grow your business with our authentic homemade pickles.
            </p>
          </div>
        </section>

        <section className="py-16 px-8 md:px-[140px] bg-[#f8f8f8]">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-[#272727] mb-12 text-center">Why Partner With Us?</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              {benefits.map((benefit, index) => (
                <div key={index} className="bg-white p-6 rounded-lg shadow-sm text-center">
                  <div className="w-16 h-16 bg-[#8e0707] rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-3xl">{benefit.icon}</span>
                  </div>
                  <h3 className="text-xl font-bold text-[#272727] mb-2">{benefit.title}</h3>
                  <p className="text-[#272727]/70">{benefit.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-16 px-8 md:px-[140px]">
          <div className="max-w-2xl mx-auto">
            <h2 className="text-3xl font-bold text-[#272727] mb-8 text-center">Apply to Become a Partner</h2>
            
            {submitted ? (
              <div className="p-8 bg-green-50 border border-green-200 rounded-lg text-center">
                <span className="text-4xl mb-4 block">✓</span>
                <h3 className="text-xl font-bold text-green-700 mb-2">Application Received!</h3>
                <p className="text-green-600">Our team will review your application and get back to you within 48 hours.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-[#272727] mb-2">Business Name *</label>
                    <input
                      type="text"
                      value={formData.businessName}
                      onChange={(e) => setFormData({...formData, businessName: e.target.value})}
                      placeholder="Your business name"
                      required
                      className="w-full px-4 py-2 border border-gray-300 rounded"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-[#272727] mb-2">Contact Person *</label>
                    <input
                      type="text"
                      value={formData.contactName}
                      onChange={(e) => setFormData({...formData, contactName: e.target.value})}
                      placeholder="Your name"
                      required
                      className="w-full px-4 py-2 border border-gray-300 rounded"
                    />
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-[#272727] mb-2">Email *</label>
                    <input
                      type="email"
                      value={formData.email}
                      onChange={(e) => setFormData({...formData, email: e.target.value})}
                      placeholder="business@email.com"
                      required
                      className="w-full px-4 py-2 border border-gray-300 rounded"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-[#272727] mb-2">Phone *</label>
                    <input
                      type="tel"
                      value={formData.phone}
                      onChange={(e) => setFormData({...formData, phone: e.target.value})}
                      placeholder="+91 XXXXXXXXXX"
                      required
                      className="w-full px-4 py-2 border border-gray-300 rounded"
                    />
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-[#272727] mb-2">Business Type *</label>
                    <input
                      type="text"
                      value={formData.businessType}
                      onChange={(e) => setFormData({...formData, businessType: e.target.value})}
                      placeholder="e.g., Retail Store, Restaurant"
                      required
                      className="w-full px-4 py-2 border border-gray-300 rounded"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-[#272727] mb-2">Location *</label>
                    <input
                      type="text"
                      value={formData.location}
                      onChange={(e) => setFormData({...formData, location: e.target.value})}
                      placeholder="City, State"
                      required
                      className="w-full px-4 py-2 border border-gray-300 rounded"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-[#272727] mb-2">Tell us about your business</label>
                  <textarea
                    value={formData.message}
                    onChange={(e) => setFormData({...formData, message: e.target.value})}
                    placeholder="Describe your business and why you'd like to partner with us..."
                    rows={5}
                    className="w-full px-4 py-2 border border-gray-300 rounded"
                  />
                </div>

                <button type="submit" className="w-full bg-[#8e0707] hover:bg-[#6b0505] text-white py-3 text-lg rounded">
                  Submit Application
                </button>
              </form>
            )}
          </div>
        </section>

        <section className="py-12 px-8 md:px-[140px] bg-[#272727]">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-2xl font-bold text-white mb-4">Have questions?</h2>
            <p className="text-white/70 mb-6">
              Reach out to us directly for partnership inquiries
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="tel:+916263957789" className="text-white/80 hover:text-white">
                +91 6263957789
              </a>
              <span className="hidden sm:inline text-white/50">|</span>
              <a href="mailto:Sunkissedtaste@gmail.com" className="text-white/80 hover:text-white">
                Sunkissedtaste@gmail.com
              </a>
            </div>
          </div>
        </section>
    </div>
  );
};

export default PartnerPage;
